// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"0bee6488","541":"c4cd4231"}[chunkId] + ".chunk.js";
};